<template>
  <footer class="footer flex flex-wrap justify-between items-center bg-brand border-b border-section_border px-3 justify-center">
    <div class="flex-1 flex justify-center text-white font-semibold text-lg w-1/2" @click="openGuide">
      <img src="@/assets/images/guide.png" alt="使い方" class="float-left w-8" />便利な使い方
    </div>
    <div v-if="getUnreadCount() > 0" class="absolute right-1 mt-1 top-0 menuIcon w-5 text-center text-sm text-white">
        {{getUnreadCount()}}
      </div>
    <div class="flex-1 flex justify-center border-l-2 text-white font-semibold text-lg w-1/2 text-center" @click="openNews">
      <img src="@/assets/images/info.png" alt="お知らせ" class="w-8" />お知らせ
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import Constants from '../../constants'
import { event } from 'vue-gtag'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      notice: 'notice/getAll',
      alreadyRead: 'notice/getAlreadyRead'
    }),
  },
  methods: {
    openNews: function () {
      //お知らせ開く
      event('お知らせ')
      this.$router.push( {name: 'news', params: { lang: this.lang } })
    },
    openGuide: function () {
      //ユーザーガイドを開く
      event('ユーザーガイド')
      window.open(Constants.USER_GUIDE)
    },
    getUnreadCount: function () {
      return this.notice.length - this.notice.filter(n => this.alreadyRead.includes(n.id)).length
    }
  }
}
</script>

<style lang="scss" scoped>
.menuIcon {
  border-radius: 50%;
  background-color: rgb(239 68 68);
}
</style>
